import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import WidgetsIcon from '@mui/icons-material/Widgets'
import { AccordionDetails, AccordionSummary, Box, IconButton, Typography, type SvgIconTypeMap } from '@mui/material'
import Accordion from '@mui/material/Accordion'
import { type OverridableComponent } from '@mui/material/OverridableComponent'
import { InvoiceCloudFrame } from 'components/domain'
import { MButton, Text } from 'components/ui'
import { MESSAGES, PAY_TOOLS } from 'config'
import { useAuth } from 'context'
import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { useMobileBreakpoints } from 'utils/hooks/useMobileBreakpoints'
import { isNil, last } from 'lodash'

interface IQuickLinks {
    title: string
    Icon: OverridableComponent<SvgIconTypeMap<object, 'svg'>>
    page?: number
    link?: string
}

const QuickLinks = (): JSX.Element => {
    const isMobile = useMobileBreakpoints()
    const { billing, isLoading } = useAuth()
    const { enqueueSnackbar } = useSnackbar()

    const handleItem = (item: IQuickLinks): void => {
        if (item.title === 'View Bill') {
            handleDownloadBill()
        }
    }
    const [isExpanded, setIsExpanded] = useState<boolean>(false)

    const handleAccordionClick = (): void => {
        setIsExpanded(!isExpanded)
    }
    const handleDownloadBill = (): void => {
        const billDisplayURL = last(billing?.billing)?.billDisplayURL
        if (!isNil(billDisplayURL) && billDisplayURL !== '') {
            window.open(billDisplayURL, '_blank', 'noopener,noreferrer')
        } else {
            enqueueSnackbar(MESSAGES.BILL_PDF_ERROR, {
                variant: 'error',
                autoHideDuration: 5000
            })
        }
    }
    return (isMobile
        ? (
            <>
                <Box mt={2}>
                    <Accordion onClick={handleAccordionClick}>
                        <AccordionSummary
                            expandIcon={<IconButton disableRipple={true} size="small" sx={{ bgcolor: '#E5E5F6' }}>{isExpanded ? <RemoveIcon sx={{ color: '#3532F4' }} /> : <AddIcon sx={{ color: '#3532F4' }} />}</IconButton>}
                        >
                            <Box display="flex" gap={1} p={0.5}>
                                <WidgetsIcon sx={{ color: '#3532F4' }} />
                                <Typography >Quick Links</Typography>
                            </Box>

                        </AccordionSummary>
                        <AccordionDetails>
                            {PAY_TOOLS.map((tool, index) => (
                                <InvoiceCloudFrame key={index} page={tool.page}>
                                    <MButton
                                        key={index}
                                        variant="contained"
                                        size="medium"
                                        texttransform='none'
                                        bgcolor='#EFEFFA'
                                        sx={{
                                            color: '#010B0E',
                                            paddingX: 2,
                                            paddingY: 1.5,
                                            marginBottom: 1.5,
                                            justifyContent: 'left'
                                        }}
                                        fullWidth
                                        startIcon={<tool.Icon sx={{ color: '#3532F4' }} />}
                                        onClick={() => {
                                            handleItem(tool)
                                        }}
                                        disabled={tool.title === 'View Bill' && isNil(billing)}
                                    >
                                        {tool.title}
                                    </MButton>
                                </InvoiceCloudFrame>
                            ))}
                        </AccordionDetails>

                    </Accordion>
                </Box>
            </>
        )
        : (
            <>
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    width="100%"
                    zIndex={999}
                    py={3}
                    px={5}
                    bgcolor="#F9F9FD"
                    border="2px solid #EFEFFA"
                >
                    <Text color="#5D6365" fontSize="12px">
                        QUICK LINKS
                    </Text>
                    <Box display="flex" flexDirection="row" gap={3}>
                        {PAY_TOOLS.map((tool, index) => (
                            <InvoiceCloudFrame key={index} page={tool.page}>
                                <MButton
                                    key={index}
                                    variant="contained"
                                    texttransform="none"
                                    rounded="true"
                                    size="large"
                                    sx={{
                                        background: '#EFEFFA',
                                        boxShadow: 'none',
                                        color: '#010B0E',
                                        '&:hover': {
                                            color: '#fff'
                                        }
                                    }}
                                    startIcon={<tool.Icon sx={{ color: '#3532F4' }} />}
                                    onClick={() => {
                                        handleItem(tool)
                                    }}
                                    disabled={(tool.title === 'View Bill' && isNil(billing)) || isLoading}
                                >
                                    {tool.title}
                                </MButton>
                            </InvoiceCloudFrame>
                        ))}
                    </Box>
                </Box>
            </>
        ))
}

export default QuickLinks
